module.exports = __webpack_public_path__ + "static/media/importICloud4.ecc76f5e.png";